import { LayerType } from '@/views/map/layers/types';
import { useSmallScreen } from '@/hooks/useWindowDimension';
import { CriticalTreesLegend } from './CriticalTreesLegend';
import type { SelectionProps } from './MapLayerOption';
import { MapLayerOption } from './MapLayerOption';

export const CriticalTreesLayerOption = (props: SelectionProps) => {
  const isSmallScreen = useSmallScreen();

  return (
    <MapLayerOption
      title="By critical trees yes/no"
      value={LayerType[LayerType.critical_trees]}
      {...props}
    >
      {isSmallScreen &&
        props.selected === LayerType[LayerType.critical_trees] && (
          <CriticalTreesLegend />
        )}
    </MapLayerOption>
  );
};
